import { Box, Stack, Table, Text, Title } from '@mantine/core';
import dayjs from 'dayjs';

import { useGetManagerDevices } from '../api/getManagerDevices';

import { ListLoader } from '@/components';

export const ManagerDevices = () => {
  const { data, isLoading, isError } = useGetManagerDevices();

  if (isLoading) {
    return <ListLoader />;
  }

  if (isError) {
    return (
      <Box p="md">
        <Text c="red">Failed to load manager devices</Text>
      </Box>
    );
  }

  const managers = data?.managers ?? [];
  const models = data?.models ?? [];

  return (
    <Box p="md">
      <Stack gap="lg">
        <Stack gap={4}>
          <Title order={3}>Manager devices</Title>
          <Text c="dimmed" size="sm">
            Phones managers last opened the mobile CRM on. The most common models are the regression
            pool.
          </Text>
        </Stack>

        {managers.length === 0 ? (
          <Text c="dimmed">
            No devices yet. They appear after a manager signs in from the mobile app.
          </Text>
        ) : (
          <>
            {models.length === 0 ? (
              <Text c="dimmed">No phone has been opened in the last 6 months.</Text>
            ) : (
              <Table highlightOnHover withTableBorder>
                <Table.Thead>
                  <Table.Tr>
                    <Table.Th>Model</Table.Th>
                    <Table.Th>Managers</Table.Th>
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {models.map((item) => (
                    <Table.Tr key={item.model}>
                      <Table.Td>{item.model}</Table.Td>
                      <Table.Td>{item.count}</Table.Td>
                    </Table.Tr>
                  ))}
                </Table.Tbody>
              </Table>
            )}

            <Table highlightOnHover withTableBorder>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Manager</Table.Th>
                  <Table.Th>Department</Table.Th>
                  <Table.Th>Model</Table.Th>
                  <Table.Th>OS</Table.Th>
                  <Table.Th>App</Table.Th>
                  <Table.Th>Last seen</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {managers.map((manager) => (
                  <Table.Tr key={manager._id}>
                    <Table.Td>{manager.username}</Table.Td>
                    <Table.Td>{manager.department}</Table.Td>
                    <Table.Td>{manager.device.model}</Table.Td>
                    <Table.Td>
                      {manager.device.os} {manager.device.osVersion}
                    </Table.Td>
                    <Table.Td>{manager.device.appVersion}</Table.Td>
                    <Table.Td>
                      {dayjs(manager.device.lastSeenAt ?? manager.device.updatedAt).format(
                        'DD.MM.YYYY HH:mm'
                      )}
                    </Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          </>
        )}
      </Stack>
    </Box>
  );
};
